import { useState } from 'react'

import {
  COLOR_FORMAT_HEX,
  COLOR_PICKER_DEFAULT_HEX,
} from '../../../../ColorPicker.constants'
import { useRisingEdgeEffect } from '../../../../ColorPicker.hooks'
import {
  getDisplayColorValue,
  parseColorByFormat,
  parseStrictHexManualInput,
} from '../../../../ColorPickerField'

export function useColorPickerPreviewHexInput({
  color,
  commitHex,
  isPopoverOpen,
  setIsValueInputFocused,
}) {
  const [text, setText] = useState(() =>
    getDisplayColorValue(color, COLOR_FORMAT_HEX)
  )
  const [hexInputFocused, setHexInputFocused] = useState(false)

  const [prevColor, setPrevColor] = useState(color)

  // Sync the editable text to the `color` prop during render (the documented
  // alternative to syncing via an effect).
  if (color !== prevColor) {
    setPrevColor(color)
    setText(getDisplayColorValue(color, COLOR_FORMAT_HEX))
  }

  function handlePopoverOpen() {
    setHexInputFocused(false)
  }

  useRisingEdgeEffect({ value: isPopoverOpen, onRisingEdge: handlePopoverOpen })

  function handleHexInputFocus() {
    setHexInputFocused(true)
  }

  function handleHexInputChange(event) {
    const next = event.target.value

    setText(next)

    const parsed = parseStrictHexManualInput(next)

    if (parsed) {
      commitHex(parsed)
    }
  }

  function handleHexInputBlur() {
    setHexInputFocused(false)
    setIsValueInputFocused(false)

    const trimmed = text.trim()

    if (!trimmed) {
      commitHex(COLOR_PICKER_DEFAULT_HEX)
      setText(COLOR_PICKER_DEFAULT_HEX)

      return
    }

    const parsed = parseColorByFormat(text, COLOR_FORMAT_HEX)

    if (parsed) {
      commitHex(parsed)
      setText(getDisplayColorValue(parsed, COLOR_FORMAT_HEX))
    } else {
      setText(getDisplayColorValue(color, COLOR_FORMAT_HEX))
    }
  }

  return {
    handleHexInputBlur,
    handleHexInputChange,
    handleHexInputFocus,
    hexInputFocused,
    text,
  }
}
